import type {ReactElement} from 'react';
import React from 'react';
import {HumanInputType, RejectionBehavior} from '@Components/ai-chat-window/ai-chat-window.types';
import type {StreamComponentRegistration} from '@Components/ai-chat-window/lib/stream-component-registry.types';
import {StreamComponentType} from '@Components/ai-chat-window/lib/stream-component-registry.types';
import type {HumanInputButtonsProps} from './human-input-buttons.types';
import {HumanInputButtons} from './human-input-buttons';

const HUMAN_INPUT_TYPES = new Set<string>(Object.values(HumanInputType));
const REJECTION_BEHAVIORS = new Set<string>(Object.values(RejectionBehavior));

function parseHumanInputType(value: unknown): HumanInputType {
  if (typeof value === 'string' && HUMAN_INPUT_TYPES.has(value)) {
    return value as HumanInputType;
  }
  return HumanInputType.BOOLEAN;
}

function parseRejectionBehavior(value: unknown): RejectionBehavior {
  if (typeof value === 'string' && REJECTION_BEHAVIORS.has(value)) {
    return value as RejectionBehavior;
  }
  return RejectionBehavior.STOP;
}

export const humanInputButtonsRegistration: StreamComponentRegistration<StreamComponentType.HUMAN_INPUT_BUTTONS, HumanInputButtonsProps> = {
  componentType: StreamComponentType.HUMAN_INPUT_BUTTONS,
  parseProps: (props: Record<string, unknown>): HumanInputButtonsProps => {
    return {
      resumeToken: typeof props.resumeToken === 'string' ? props.resumeToken : '',
      inputType: parseHumanInputType(props.inputType),
      rejectionBehavior: parseRejectionBehavior(props.rejectionBehavior),
    };
  },
  render: (props: HumanInputButtonsProps, context): ReactElement => {
    return React.createElement(HumanInputButtons, {
      ...props,
      chatId: context.chatId,
      onResumeWorkflow: context.onResumeWorkflow,
    });
  },
};
